import relatorioAtendimento from './relatorioAtendimento'

export default [
    ...relatorioAtendimento,
]